document.addEventListener('DOMContentLoaded', () => {
    const galleries = document.querySelectorAll('[data-js="gallery"] [data-fancybox]');
    if (!galleries.length) return;

    Fancybox.bind('[data-js="gallery"] [data-fancybox]', {
        Thumbs: { autoStart: true },
        Toolbar: { display: ["close"] }
    });

    document.querySelectorAll('[data-js="gallery"]').forEach((galleryEl) => {
        const btn = galleryEl.querySelector('[data-js="gallery-more"]');
        if (!btn) return;

        const items = Array.from(galleryEl.querySelectorAll('.gallery .item'));
        if (!items.length) return;

        const initial = parseInt(galleryEl.dataset.galleryInitial, 10) || 0;
        const step = initial || 4;

        const updateButton = () => {
            const hiddenCount = items.filter(el => el.classList.contains('is-hidden')).length;
            btn.style.display = hiddenCount > 0 ? '' : 'none';
        };

        updateButton();

        btn.addEventListener('click', () => {
            const hidden = items.filter(el => el.classList.contains('is-hidden'));
            hidden.slice(0, step).forEach(el => el.classList.remove('is-hidden'));
            updateButton();
        });
    });
});